import { c as _c } from "react/compiler-runtime";
import { faCircleInfo, faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
type QuestionHelperProps = {
  type: 'hint' | 'info';
  children?: ReactNode;
  className?: string;
};
export const QuestionHelper = t0 => {
  const $ = _c(5);
  const {
    type,
    children,
    className
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== t || $[3] !== type) {
    t1 = children ? <div className={mergeTailwindClasses("border-border rounded-lg border", className)}><p className="flex items-center gap-2 p-2">{type === "hint" ? <><FontAwesomeIcon icon={faCircleQuestion} />{t("question.helper.info")}</> : <><FontAwesomeIcon icon={faCircleInfo} />{t("question.additional.label")}</>}</p><div className="bg-border h-px" /><div className="p-2">{children}</div></div> : null;
    $[0] = children;
    $[1] = className;
    $[2] = t;
    $[3] = type;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};